module.exports = __webpack_public_path__ + "static/12-1-56f0e2a3d71c002a2848ce892c695c64.jpg";